import { Platform } from "@angular/cdk/platform";
import { Injectable } from "@angular/core";
import clevertap from "clevertap-web-sdk";

export enum CleverTapEvent {
  APPOINTMENT_CONFIRMED = "appointment_confirmed",
  APPOINTMENT_CANCELLED = "appointment_cancelled",
  APPOINTMENT_SCHEDULED = "appointment_scheduled",
  APPOINTMENT_RESCHEDULED = "appointment_rescheduled",
  RESCHEDULED_REQUESTED = "rescheduled_requested",
  AGENT_QUEUE_REQUESTED = "agent_queue_requested",
  TRIAGE_COMPLETED = "triage_completed",
  SCHEDULE_COMPLETED = "schedule_completed",
}

@Injectable({
  providedIn: "root",
})
export class CleverTapService {
  constructor(private readonly platform: Platform) {}
  registerEvent$(eventName: CleverTapEvent, eventData: any) {
    clevertap.event.push(eventName, {
      ...eventData,
      timestamp: new Date().toISOString(),
      device_type: this.platform.isBrowser ? "web" : "mobile",
    });
  }
  registerUser$(data: any) {
    clevertap.onUserLogin.push(data);
  }
  registerCleverTapEvent(event: any, body: any) {
    // eslint-disable-next-line no-console
    //console.log('registerCleverTapEvent, my-coupons');
    // eslint-disable-next-line no-console
    //console.log(event, body);
    //this.registerEvent$(event, body);
  }

  registerOnUserLogin(data: any) {
    /*
    this.registerUser$({
      Site: {
        Name: `${data.firstName} ${data.lastName}`,
        Identity: data.identificationNumber,
        Email: data.email,
        Phone: `+${data.countryCode}${data.phoneNumber}`,
        Gender: data.gender === 1 ? 'M' : 'F',
      },
    });
    */
  }
}
